import { AdjacentType, BranchingQueryDefinition, getClosestPartnerInclusiveItemTypeToGroupNestedAscendingQueryDef, getParentEdgeTypeId, NodeEdgeMapper, } from '@iotv/datamodel-core';
import { ConsumerDao } from '../ConsumerDAO';
import { classDerivedDeviceEnabledTypes } from '@iotv/datamodel';
import { ComparisonType, LogicalOperatorType } from '@iotv/iotv-v3-types';
/** Gets the customer that owns the current partner group. Should always be seed customer.
 * */
export const partnerCustomerQuery = async (user) => {
    let resNem = new NodeEdgeMapper();
    const userToPartnerCustomer = getClosestPartnerInclusiveItemTypeToGroupNestedAscendingQueryDef({
        sourceItemType: 'User',
        groupDefiningObjectTypeId: 'Customer',
    });
    const cust_res = await ConsumerDao.getGraphQueryRequestV2({ contextObjects: [user], query: userToPartnerCustomer });
    if (cust_res.err) {
        console.error(cust_res.err);
        return resNem;
    }
    if (!cust_res.data) {
        console.warn('partnerRoleQueries', 'No err but no data on cust res');
        return resNem;
    }
    // Previously run userTypeRoleQuery will have gotten the actual user obj, current res includes user object but its only the zombie, not the whole object.
    // So if we add it now we'll overwrite the fetched user
    // We want to retain edges though (they might have been fetched on this query) so just remove user
    cust_res.data.removeNode(user);
    resNem.union(cust_res.data);
    return resNem;
};
/** Gets the partner object from the partner user with debug messages if it fails
 * @param user - user obj from UserView, so not full fetched user
 * */
export const partnerVisibleGroupsQuery = async (user) => {
    let resNem = new NodeEdgeMapper();
    const UserToPartnerQuery = getClosestPartnerInclusiveItemTypeToGroupNestedAscendingQueryDef({
        sourceItemType: 'User',
        groupDefiningObjectTypeId: 'Partner',
    });
    const partner_res = await ConsumerDao.getGraphQueryRequestV2({ contextObjects: [user], query: UserToPartnerQuery });
    if (!partner_res.data) {
        return resNem;
    }
    // Previously run userTypeRoleQuery will have gotten the actual user obj, current res includes user object but its only the zombie, not the whole object.
    // So if we add it now we'll overwrite the fetched user
    // We want to retain edges though (they might have been fetched on this query) so just remove user
    partner_res.data.removeNode(user);
    resNem.union(partner_res.data);
    const partners = resNem.getNodesOfType('Partner');
    if (partners.length > 1) {
        console.warn(`User ${user.name} found more than one partner, using first`, partners);
    }
    if (partners.length === 0) {
        console.error(`User ${user.name} has no partner parent`, resNem);
        return resNem;
    }
    /** Go from partner -> relevant groups */
    const partnerApexQuery = new BranchingQueryDefinition({
        id: 'partnerApex',
        path: [
            {
                objectTypeId: 'Partner',
                adjacencyType: AdjacentType.SUBJECT,
            },
        ],
        subQueries: [],
    });
    classDerivedDeviceEnabledTypes.forEach((det) => {
        const detSubQuery = new BranchingQueryDefinition({
            id: `partnerTo${det}GroupsQuery`,
            path: [
                {
                    objectTypeId: 'Group',
                    adjacencyType: AdjacentType.CHILD,
                    edgeTypeId: getParentEdgeTypeId('Group', 'Partner'),
                    nodeFilters: [{ filters: [{ key: 'supportedType', predicate: ComparisonType.EQUALS, value: det }], setOperation: LogicalOperatorType.AND }],
                },
            ],
            subQueries: [],
        });
        partnerApexQuery.addSubQuery(detSubQuery);
    });
    const partnerVisibleGroups_res = await ConsumerDao.getGraphQueryRequestV2({ contextObjects: [partners[0]], query: partnerApexQuery });
    if (partnerVisibleGroups_res.data) {
        resNem.union(partnerVisibleGroups_res.data);
    }
    return resNem;
};
